var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-5" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("fb-paginacion", {
          attrs: { total: _vm.pages, max: _vm.maxPages },
          model: {
            value: _vm.page,
            callback: function($$v) {
              _vm.page = $$v
            },
            expression: "page"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }